import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PlessService } from '../../shared/pless-service.model';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { PlessHttp } from '../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../commons/kymw00/pless-dialog-service-sub';
import { PlessResponse } from 'src/app/shared/vo/pless-response.model';
import { PlessJsonResponder } from 'src/app/shared/http/pless-json-responder.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * APIと通信する際に使用する共通クラス(ファイルアップロード用)
 * APIと通信するサービスは基本的にこのクラスを継承する
 */
@Injectable()
export abstract class PlessJsonUploadServiceSub<T> extends PlessJsonResponder<T> {

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * リクエスト送信
   *
   * @param id PlessServiceで指定したAPIのID
   * @param body 送信する内容
   * @param file 送信するファイル
   */
  sendFile(id: string, body: PlessRequest|string, file: File) {
    const csrfToken = document.cookie.split('; ').find(row => row.startsWith('XSRF-TOKEN='));
    const jwt = document.cookie.split('; ').find(row => row.startsWith('PEACE_JWT='));
    const formData = new FormData();
    formData.append('jsonData', ((typeof body === 'string') ? body : JSON.stringify(body)));
    formData.append('Filename', file.name);
    formData.append('Filedata', file);
    let response: Observable<HttpResponse<PlessResponse<T>>>;
    response = this.plessHttp.post<PlessResponse<T>>(PlessService.SERVICE[id].url, formData, {
      headers: new HttpHeaders({
        'X-XSRF-TOKEN': csrfToken ? csrfToken.split('=')[1] : '',
        Authorization: jwt ? 'Bearer ' + jwt.split('=')[1] : '',
      }), responseType: 'json', withCredentials: true
    });
    super.result(response, PlessService.SERVICE[id]);
  }
}
